import { render, staticRenderFns } from "./APrograma-sessiones.vue?vue&type=template&id=21579ba0"
import script from "./APrograma-sessiones.vue?vue&type=script&lang=js"
export * from "./APrograma-sessiones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports